module.exports = __webpack_public_path__ + "static/img/trade.4fbbd27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/features/trade.png
// module id = chig
// module chunks = 6